import styled, { css } from "styled-components";

export const Cookie = styled.div`
    background-color: ${p => p.theme.c.white};
    box-shadow: 0 0 19px 0 ${p => p.theme.c.blackShadow2};
    text-align: center;
    z-index: 11;
    position: relative;

    ${p =>
        p.theme.sm.min(css`
            height: 82px;
        `)}

    &.CookieClosed {
        transition: 400ms;
        height: 0;
        overflow: hidden;
    }

    .button {
        ${p =>
            p.theme.xs(css`
                width: 100%;
            `)}
        ${p =>
            p.theme.sm.min(css`
                margin-bottom: 0;
                width: 166px;
                padding: 6px;
            `)}
        font-size: 15px;
    }
`;

export const Container = styled.div`
    ${p =>
        p.theme.sm.min(css`
            display: flex;
        `)}

    ${p =>
        p.theme.xs(css`
            padding: 1px 16px;
        `)}

    margin: auto;
    justify-content: center;
    align-items: center;
`;

export const Text = styled.div`
    ${p =>
        p.theme.xs(css`
            margin: 18px 0;
        `)}

    ${p =>
        p.theme.sm.min(css`
            width: 460px;
            margin: 31px 18px;
        `)}

    text-align: left;
    font-size: 16px;

    color: ${p => p.theme.c.active};

    .link {
        font-size: 14px;
    }
`;
